@if (model?.data?.store_name) {
<a [routerLink]="model?.data?.url">
    <div class="ratio-1-1 overflow-hidden m-l-3 m-l-4-s  m-r-3 m-r-5-s b-radius-max bg-col-12">
        @if (model.data.images?.length) {
        <img [dfImage]="model.data.images[0]"
             [ratio]="1"
             fill>
        }
    </div>
    <div class="center p1">
        {{model?.data?.store_name}}
    </div>
</a>
}